import React, { FunctionComponent, useState } from 'react';
import Pokemon from '../models/pokemon';
import { useHistory } from 'react-router-dom';
import formatDate from '../helpers/format-date';
import formatType from '../helpers/format-type';
import './pokemon-card.css';
  
type Props = {
  pokemon: Pokemon,
  borderColor?: string
};
  
const PokemonCard: FunctionComponent<Props> = ({pokemon, borderColor ='green'}) => {

  const [color, setColor] = useState<string>();
  const history = useHistory();

  const showBorder = () => {
    setColor(borderColor);
  }
    
  const hideBorder = () => {
    setColor('ghostwhite');
  }

  const goToPkemon = (id: number) => {
    history.push(`/pokemons/${id}`);
  }

  return (
    <div className="col s6 m4" onClick={() => goToPkemon(pokemon.id)} onMouseEnter={showBorder} onMouseLeave={hideBorder}>
      <div className="card horizontal" style={{borderColor: color}}>
        <div className="card-image"> 
          <img src={pokemon.picture} alt={pokemon.name}/>
        </div>
        <div className="card-stacked">
          <div className="card-content">
            <p>{pokemon.name}</p>
            {/*<p><small>{pokemon.created.toString()}</small></p>*/}
            <p><small>{formatDate(pokemon.created)}</small></p>
            <p>
              {pokemon.types.map(type => (
                <span key={type} className={formatType(type)}>{type}</span>
              ))}
            </p>
          </div>
        </div>
      </div> 
    </div>
  );
}
  
export default PokemonCard;